import { z } from "zod";

/**
 * The audit endpoint puts the table and the filter column straight into the query it runs, so a
 * free string would let a caller read any table the `authenticated` role can reach rather than an
 * audit trail. Both are therefore closed sets. Adding an audit table means adding it here, which
 * is the point: the endpoint reads audit trails and nothing else.
 */
export const AUDIT_TABLES = ["projectsAudit", "notesAudit", "protocolsAudit"] as const;
export const AUDIT_IDENTIFIER_KEYS = ["projectId", "noteId", "protocolId"] as const;

export const getAuditQuerySchema = z.object({
	auditTable: z.enum(AUDIT_TABLES),
	identifierKey: z.enum(AUDIT_IDENTIFIER_KEYS),
	identifierValue: z.string(),
});

export type GetAuditQuerySchema = z.infer<typeof getAuditQuerySchema>;
